module.exports = __webpack_public_path__ + "img/formplus.d6e7e001.svg";